import { Mail, Phone, Facebook, Link2, Instagram, Map } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    // <footer className="mt-auto bg-[#fffbf0]" style={{ fontFamily: "Gambetta" }}>
    <footer className="mt-auto bg-[#f0f0f0]" style={{ fontFamily: "Gambetta" }}>
      {/* Main Footer Content */}
      <div className="mx-auto max-w-[80vw] py-2">
        <div className="grid grid-cols-1 gap-y-6 sm:grid-cols-2 lg:grid-cols-4">
          {/* Company Info */}
          <div className="text-center sm:text-left">
            <h1
              className="mb-4 text-xl font-bold tracking-widest text-[#1a4fa3] sm:text-2xl"
              style={{ fontFamily: "GT-Ultra" }}
            >
              Century Group
            </h1>
            <p className="mb-3 tracking-wider">
              At Century Group, we build lasting relationships with our
              customers, understanding their needs, exceeding expectations, and
              delivering personalized service.
            </p>
          </div>

          {/* Quick Links */}
          <div className="text-center sm:text-left">
            <h4
              className="mb-4 flex items-center justify-start text-lg font-semibold tracking-widest text-[#1a4fa3]"
              style={{ fontFamily: "GT-Ultra" }}
            >
              <Link2 className="mr-2" /> Links
            </h4>
            <div className="flex flex-col items-start">
              <a
                target="_blank"
                href="https://www.facebook.com/people/CenturyGroup21/61566827638355/?mibextid=LQQJ4d&rdid=YaVV60zqSYqlXk0J&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2Fo9HvFxKmkYcSFozL%2F%3Fmibextid%3DLQQJ4d"
                className="mb-3 tracking-wider"
              >
                <div className="flex items-center">
                  <Facebook className="mr-2 h-5 w-5" />
                  Facebook
                </div>
              </a>
              <a
                target="_blank"
                href="https://www.instagram.com/centurygroup.21/"
                className="mb-3 tracking-wider"
              >
                <div className="flex items-center">
                  <Instagram className="mr-2 h-5 w-5" />
                  Instagram
                </div>
              </a>
              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5" />
                <a
                  target="_blank"
                  href="mailto:info@centurygroup.co.in"
                  className="tracking-wider"
                >
                  info@centurygroup.co.in
                </a>
              </div>
            </div>
          </div>

          {/* Contact */}
          <div className="text-center sm:text-left">
            <h4
              style={{ fontFamily: "GT-Ultra" }}
              className="mb-4 flex items-center justify-start text-lg font-semibold tracking-widest text-[#1a4fa3]"
            >
              <Phone className="mr-2" />
              Contact Us
            </h4>
            <div className="flex flex-col items-start space-y-2 lg:ml-4">
              <a
                target="_blank"
                href="tel:+91 9302921921"
                className="text-sm tracking-wider sm:text-base"
              >
                +91 93029 21921
              </a>
              <a
                target="_blank"
                href="tel:+91 9303921921"
                className="text-sm tracking-wider sm:text-base"
              >
                +91 93039 21921
              </a>

              <a
                target="_blank"
                href="https://api.whatsapp.com/send/?phone=08817521921&text&type=phone_number&app_absent=0"
                className="transition-colors"
              >
                <span className="text-sm tracking-wider sm:text-base">
                  +91 88175 21921
                </span>
              </a>
            </div>
          </div>

          {/* Location */}
          <div className="text-center sm:text-left">
            <h1
              style={{ fontFamily: "GT-Ultra" }}
              className="mb-4 flex items-center justify-start text-lg font-semibold tracking-widest text-[#1a4fa3]"
            >
              <Map className="mr-2" />
              Our Locations
            </h1>
            <div className="flex flex-col">
              {/* <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14666.773933479199!2d79.8959753!3d23.2178386!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3981b033c2e3a805%3A0x92bc061dec4064c1!2snakshatranagar!5e0!3m2!1sen!2sin!4v1743762243184!5m2!1sen!2sin"
                width="300"
                height="200"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe> */}
              <a
                target="_blank"
                href="https://maps.app.goo.gl/fFa6XUQaFUEHwV858"
                className="text-start tracking-wider"
              >
                Nakshatra Nagar, Katangi Rd, Karmeta, Nandni Ronsara, Jabalpur, Madhya Pradesh 482002
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#1a4fa3]">
        <div className="mx-auto max-w-[80vw] p-1">
          <div className="flex flex-col text-center">
            <div className="mb-1 text-xs sm:text-sm">
              <span>© {currentYear} Century Group. All rights reserved.</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
